import React, { useEffect, useRef } from "react";
import "./Estructuras.css";
import emailjs from '@emailjs/browser';


const Estructuras = () => {
    const bannerRef = useRef(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) bannerRef.current.classList.add("estructuras-visible");
            },
            { threshold: 0.3 }
        );
        if (bannerRef.current) observer.observe(bannerRef.current);
    }, []);

    return (
        <section className="estructuras">
            {/* === SECCIÓN 1: Banner con animación === */}
            <div className="estructuras-banner" ref={bannerRef}>
                <img src="/images/estructuras/f-09.png" alt="espectacular" className="estructuras-espectacular" />
                <div className="estructuras-banner-texto">
                    <h3>Banners<br></br>y estructuras publicitarias</h3>
                    <img src="/images/logo/MotiPuntos.svg" style={{ height: '0.7rem' }} alt="puntos decorativos"></img>
                    <p className="p-etiquetas">Roll Up · Carpas · Banners Todo para tu expo</p>
                </div>
            </div>

            {/* === SECCIÓN 2: Texto + Imagen edificio === */}
            <div className="estructuras-info">
                <p className="estructuras-subtitle">we make it <span>happen.</span></p>

                <div className="estructuras-info-contenido">
                    <div className="estructuras-info-texto">
                        <div className="estructuras-tag">
                            <img src="/images/estructuras/estructura-ico.svg" style={{ height: '1rem', marginRight: '1rem' }} alt="estructuras icon"></img>
                            Estructuras
                        </div>
                        <h2>
                            Dale estructura a tu marca<br></br>
                        </h2>
                        <p>
                            Somos tu mejor opción en estructuras gracias a nuestras alianzas internacionales, que garantizan <b> calidad premium y durabilidad.</b>,
                            Nuestras tecnologías de impresión harán que tus ideas brillen.<br></br><br></br>
                            <b>Haz tu compra en línea.</b>
                        </p>
                        <p className="estructuras-cta">
                            En Moti Digital lo hacemos posible, <a href="#cotiza">solicita tu cotización:</a>
                        </p>
                        <div className="estructuras-input-wrapper">
                             <form
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    const form = e.target;
                                    const button = form.querySelector("button");
                                    const input = form.querySelector("input");

                                    button.disabled = true;
                                    const originalText = button.textContent;
                                    button.textContent = "Enviando...";

                                    try {
                                        const serviceID = "service_lxg5sht";
                                        const templateID = "template_epehkcc";
                                        const publicKey = "4f0iRLKGvmXsd0ASA";

                                        const params = {
                                            from_name: input.value,
                                            message: `Me interesan sus productos de Estructuras y displays. Me pueden contactar al correo ${input.value}, me estoy contactando desde motidigital.com `,
                                        };

                                        console.log("📤 Enviando con EmailJS...");
                                        console.log({ serviceID, templateID, publicKey, params });

                                        const res = await emailjs.send(serviceID, templateID, params, publicKey);
                                        console.log("✅ Respuesta EmailJS:", res);

                                        if (res.status === 200) {
                                            button.textContent = "Enviado ✔";
                                            input.value = "";
                                            setTimeout(() => {
                                                button.textContent = originalText;
                                                button.disabled = false;
                                            }, 3000);
                                        } else {
                                            throw new Error("Error en el envío");
                                        }
                                    } catch (error) {
                                        console.error("❌ Error al enviar con EmailJS:", error);

                                        button.textContent = "Error ✖";
                                        setTimeout(() => {
                                            button.textContent = originalText;
                                            button.disabled = false;
                                        }, 2500);
                                    }
                                }}
                            >
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Tu correo electrónico"
                                    required
                                />
                                <button type="submit">Empecemos</button>
                            </form>
                        </div>
                    </div>

                    <div className="estructuras-info-imagen">
                        <img src="/images/estructuras/estructura.png" alt="Estructuras en edificio" />
                    </div>
                </div>
            </div>

            <div className="estructuras-final">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="estructuras-dots" />
                <h2>
                    ¿Listo para hacer crecer <br />
                    <span>tu empresa?</span>
                </h2>

                {/* Doble marquee - VERSIÓN SIMPLE */}
                <div className="estructuras-marquees">
                    <div className="estructuras-marquee estructuras-line1">
                        <span>
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                        </span>
                        <span>
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                            COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS · COMPRA TUS ·
                        </span>
                    </div>

                    <div className="estructuras-marquee estructuras-line2">
                        <span>
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                        </span>
                        <span>
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                            ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS · ESTRUCTURAS PUBLICITARIAS ·
                        </span>
                    </div>
                </div>

                {/* Slider semicircular */}
                <div className="estructuras-slider">
                    <div className="estructuras-slider-track">
                        <img src="/images/estructuras/slider/1.png" alt="estructura 1" />
                        <img src="/images/estructuras/slider/2.png" alt="estructura 2" />
                        <img src="/images/estructuras/slider/3.png" alt="estructura 3" />
                        <img src="/images/estructuras/slider/4.png" alt="estructura 4" />
                        <img src="/images/estructuras/slider/5.png" alt="estructura 5" />
                    </div>
                </div>
            </div>

            {/* === SECCIÓN 3: Opción estratégica === */}
            <div className="estructuras-opcion">
                <img src="/images/logo/Moti Logo.svg" alt="decorativo" className="estructuras-opcion-icon" />

                <div className="estructuras-opcion-card">
                    <div className="estructuras-opcion-left">
                        <h2>Estructuras que<br></br> potencian tu MARCA</h2>
                        <p>Compre en nuestra tienda en línea</p>
                        <button className="estructuras-btn-cotizar">Cotizar ahora</button>
                    </div>

                    <div className="estructuras-opcion-right">
                        <div className="estructuras-opcion-item">
                            <div>
                                <p> • <b>Banderas Publicitarias:</b><br></br>Estructuras versátiles y llamativas, perfectas para destacar tu marca en eventos o exteriores. <br></br><br></br>
                                    • <b>Manteles Publicitarios:</b><br></br>Soluciones personalizables que convierten cualquier mesa en un espacio promocional.<br></br><br></br>
                                    • <b>Carpas Publicitarias:  </b><br></br> Protección y branding en un solo producto, ideales para eventos al aire libre. <br></br><br></br>
                                    • <b>Back de Prensa:</b><br></br> Fondos profesionales para fotografías y eventos, resaltando tu imagen corporativa. <br></br><br></br>
                                    • <b>Eurofit Banner:</b><br></br>  Exhibidores modernos con gráficos intercambiables y de fácil transporte. <br></br><br></br>
                                    • <b>Mini Estructuras:</b><br></br>Versiones compactas de banderas y eurofits para escritorios o mostradores.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="estructuras-faq">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="estructuras-dots" />
                <h2>Preguntas frecuentes</h2>
                <div className="estructuras-faq-contenedor">
                    {/* Lado izquierdo - Acordeón */}
                    <div className="estructuras-faq-lista">
                        <details open>
                            <summary>¿Qué tipos de estructuras publicitarias ofrecen?</summary>
                            <p>
                                Contamos con carpas, banners roll-ups, eurofits, muros publicitarios, manteles,
                                back de prensa y banderas. Además, ofrecemos estructuras personalizadas según
                                las necesidades específicas de cada cliente.
                            </p>
                        </details>

                        <details>
                            <summary>¿Puedo comprar solo la estructura sin impresión?</summary>
                            <p>
                                Sí, ofrecemos la opción de adquirir únicamente la estructura sin impresión.
                                Ideal para clientes que ya cuentan con su propio material gráfico o desean
                                realizar la impresión por separado.
                            </p>
                        </details>

                        <details>
                            <summary>¿Puedo comprar y diseñar online?</summary>
                            <p>
                                Absolutamente. Nuestra plataforma online te permite diseñar y personalizar
                                tus estructuras en tiempo real, con vista previa instantánea y cotización
                                automática.
                            </p>
                        </details>

                        <details>
                            <summary>¿Por qué elegir sus estructuras?</summary>
                            <p>
                                Porque combinamos materiales de alta durabilidad con diseño innovador,
                                garantizando estructuras resistentes y profesionales. Además, ofrecemos
                                los mejores tiempos de entrega y soporte técnico especializado.
                            </p>
                        </details>
                    </div>

                    {/* Lado derecho - Contacto */}
                    <div className="estructuras-faq-contacto">
                        <h3>¿Tienes más dudas?</h3>
                        <p>No dudes en contactarnos para más información.</p>

                        <div className="estructuras-contacto-email">
                            <div className="estructuras-email-box">
                                <img src="/images/granformato/mail.svg" alt="email" />
                                <span>COTIZACIONES@MOTIDIGITAL.COM</span>
                                <button>Agendar una llamada</button>
                            </div>
                            <button className="estructuras-btn-whatsapp"> Cotiza tu proyecto</button>
                        </div>

                        <div className="estructuras-faq-img">
                            <img src="/images/granformato/faq-banner.png" alt="FAQ" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Estructuras;